export default {"src":"/_next/static/image/public/images/doctor_image.170150938be0d0afa01cd12b681aa8d8.svg","height":62,"width":58};